import { FC } from "react";



import { ServicesAnalyticsPageId } from "utils/useScroll";
import { 
  Box
} from "@chakra-ui/react";

import { SiEnterprisedb } from "react-icons/si";
import { SiJfrogpipelines } from "react-icons/si";
import { GrDocumentPerformance } from "react-icons/gr";
import { NextStepsSection } from "./NextSteps";

import ServiceDescriptor from "./ServiceDescriptor";
import DeliverablesSection from "./Deliverables";


import { FaDatabase, FaStream, FaShieldAlt, FaRobot } from "react-icons/fa";

export const AnalyticsService: FC = () => {
  const label =  "Data & Analytics Solutions";
  const title = "Comprehensive Data & Analytics Solutions";
  const footer = "Transform your data & analytics into a competitive advantage with tailored solutions";

  const services = [
    {
      title: "Enterprise Data Architecture",
      icon: SiEnterprisedb,
      items: [
        "Blueprint development for scalable infrastructure",
        "Technology evaluation & selection",
        "Hybrid/multi-cloud architecture patterns",
        "Legacy system modernization",
        "Data mesh/fabric implementation"
      ]
    },
    {
      title: "Analytics Pipeline Development",
      icon: SiJfrogpipelines,
      items: [
        "Real-time and batch processing systems",
        "ETL pipeline optimization",
        "Data quality framework implementation",
        "Metadata management solutions",
        "Custom connector development"
      ]
    },
    {
      title: "Performance Optimization",
      icon: GrDocumentPerformance,
      items: [
        "Query performance tuning",
        "Cost-optimized data storage and access strategies",
        "Auto-scaling solutions",
        "Data partitioning strategies",
        "Streaming data optimization"
      ]
    }
  ];
  return (
    <Box id={ServicesAnalyticsPageId}>
      <ServiceDescriptor title={title} label={label} footer={footer} services={services} nextRoute="/techadvice"/>
       <DeliverablesSection deliverables={[
          {
            icon: FaDatabase,
            title: "Technology Matrix",
            description: "Vendor comparisons for your specific use cases",
            tags: ["Evaluation", "Scoring"]
          },
          {
            icon: FaStream,
            title: "Pipeline Documentation",
            description: "Complete data flow specs with transformation logic",
            tags: ["ETL", "Airflow"]
          },
          {
            icon: FaShieldAlt,
            title: "Governance Framework",
            description: "Data quality rules + monitoring dashboard",
            tags: ["Compliance", "PII"]
          },
          {
            icon: FaRobot,
            title: "ML Feature Catalog",
            description: "Reusable features with lineage tracking",
            tags: ["Feast", "Hopsworks"]
          }
        ]} />
       <NextStepsSection title="Ready to Build Your Organization's Data and Analytics Solutions?" 
            message="Take the next step toward solving complex data problems and building awesome analytics" 
            actionHeading="Schedule Consultation" 
            actionText="Book a 90-minute discovery session to discuss your specific challenges" 
            actionLabel="Contact Me and Book Today"/>
    </Box>
  );
};




export default AnalyticsService;